const urlDomain = window.origin
const getCurrentLanguage = () => localStorage.getItem('userLanguage')

export const EXTERNAL_LINKS = {
  HELP_ZENDESK: 'https://edubook-learning.zendesk.com/hc/es-es',
  PASSWORD_RECOVERY: `${urlDomain}/${getCurrentLanguage()}/recuperar-contrasena`,
}
